import React from 'react';
import {Tab} from 'react-tabs';
import { defaultTemplate } from 'core/hoc';
import { renderIf, isSome } from 'core/utils';
import _ from 'lodash';

function BaasicTabTemplate({ t, placeholder, reference, validation, required, label, ...props }) {
	const { tReady, i18nOptions, defaultNS, reportNS, ...otherProps } = props;
	if (placeholder) {
		placeholder = t(placeholder);
	}
	let labelHtml, errorHtml;
	if (props.field) {
		let field = props.field;
		const requiredMark =
			field.rules && field.rules.indexOf('required') !== -1 ? <span className="type--color--warning">*</span> : null;
		labelHtml = (
			<label htmlFor={field.id}>
				{t(field.label)} {requiredMark}
				
				{renderIf(
					field.$rules && field.$rules.includes('required') && !isSome(field.error) && field.$value && validation
				)(
					<span className="form__label--check type--color--success">
						<i className="fa fa-check-circle"></i>
					</span>
				)}
			</label>
		);
		errorHtml = renderIf(isSome(field) && isSome(field.error))(
			<p className="type--tny type--color--error spc--bottom--tny">{t(field.error)}</p>
		);
	}
	if (label) {
		labelHtml = <label>{t(label)}</label>;
	}

	return (
		<React.Fragment>
			{labelHtml}
			{errorHtml}
			<Tab
				placeholder={placeholder}
				ref={ref => (reference != null ? reference(ref) : null)}
				{...otherProps}
			/>
		</React.Fragment>
	);
}

export default defaultTemplate(BaasicTabTemplate);